import { useAuth } from '@/auth/hyper-auth'

const overrideConfig = {
    baseURL: process.env.VUE_APP_BOARD_API_URL,
    namespace: process.env.VUE_APP_NAMESPACE,
    serviceGroup: process.env.VUE_APP_SERVICE
}
const service = {
    getBoardDocuments () {
        const { auth } = useAuth(overrideConfig)
        return auth.axiosIns.get('/boards/documents')
    },
    getBoardDocument ({ timestamp, service }) {
        const { auth } = useAuth(overrideConfig)
        return auth.axiosIns.get('/boards/documents/' + service + '/' + timestamp)
    }
}

export {
    service,
    overrideConfig,
    useAuth
}
